// extracted by mini-css-extract-plugin
export var backgroundNeutral05 = "BrochureStickyBar-module--background-neutral05--613ca";
export var backgroundNeutral10 = "BrochureStickyBar-module--background-neutral10--c7533";
export var backgroundTitaniumDark = "BrochureStickyBar-module--background-titanium-dark--04fdd";
export var backgroundWhite = "BrochureStickyBar-module--background-white--46e35";
export var content = "BrochureStickyBar-module--content--1cd90";
export var cta = "BrochureStickyBar-module--cta--9be14";
export var imgContainer = "BrochureStickyBar-module--img-container--3e889";
export var imgContainerWrapper = "BrochureStickyBar-module--img-container-wrapper--9806f";
export var innerComponent = "BrochureStickyBar-module--inner-component--77a4d";
export var isSticky = "BrochureStickyBar-module--is-sticky--421a7";
export var nav = "BrochureStickyBar-module--nav--9a6be";
export var section = "BrochureStickyBar-module--section--f3bdc";